import { ApiResponseObject } from "../../../types";
import { axios } from "../../../utils/axios";
import {
  IOvlascenaLicaPayload,
  ISvaOvlascenaLicaListaProps,
} from "./authorisedPersons.types";

const getSvaOvlascenaLicaZaPreuzimanjeMarkica = (): Promise<
  ApiResponseObject<ISvaOvlascenaLicaListaProps[]>
> => {
  return axios.get("/svaOvlascenaLicaZaPreuzimanjeMarkica");
};

const postKreirajOvlascenoLiceZaPreuzimanjeMarkica = (
  payload: IOvlascenaLicaPayload
): Promise<ApiResponseObject<ISvaOvlascenaLicaListaProps>> => {
  return axios.post("/kreirajOvlascenoLiceZaPreuzimanjeMarkica", payload);
};

const putIzmeniOvlascenoLiceZaPreuzimanjeMarkica = (
  payload: IOvlascenaLicaPayload,
  id: number | null
): Promise<ApiResponseObject<ISvaOvlascenaLicaListaProps>> => {
  return axios.put(`/izmeniOvlascenoLiceZaPreuzimanjeMarkica/${id}`, payload);
};

export const authorisedPersonsRepo = {
  getSvaOvlascenaLicaZaPreuzimanjeMarkica,
  postKreirajOvlascenoLiceZaPreuzimanjeMarkica,
  putIzmeniOvlascenoLiceZaPreuzimanjeMarkica,
};
